// Ported verbatim from the LeadMailer Design System (components/core/Badge.jsx).
import React from 'react'

export const STATUSES = [
  'pending',
  'approved',
  'scheduled',
  'sent',
  'failed',
  'rejected',
  'unsubscribed',
] as const

export type BadgeStatus = (typeof STATUSES)[number]

export interface BadgeProps {
  status?: BadgeStatus | string
  tone?: 'accent' | 'neutral'
  dot?: boolean
  children?: React.ReactNode
  style?: React.CSSProperties
}

export function Badge({ status, tone, dot = true, children, style }: BadgeProps) {
  const s: React.CSSProperties = status
    ? { color: `var(--status-${status}-fg)`, background: `var(--status-${status}-bg)` }
    : tone === 'accent'
      ? { color: 'var(--accent-text)', background: 'var(--accent-soft)' }
      : { color: 'var(--text-secondary)', background: 'var(--surface-sunken)' }

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        height: 22,
        padding: '0 8px',
        borderRadius: 'var(--radius-full)',
        fontSize: 'var(--text-xs)',
        fontWeight: 'var(--weight-medium)' as React.CSSProperties['fontWeight'],
        fontFamily: 'var(--font-sans)',
        whiteSpace: 'nowrap',
        textTransform: 'capitalize',
        ...s,
        ...style,
      }}
    >
      {status && dot ? (
        <span
          style={{
            width: 6,
            height: 6,
            borderRadius: '50%',
            background: `var(--status-${status}-dot, currentColor)`,
          }}
        />
      ) : null}
      {children ?? status}
    </span>
  )
}
